module.exports = __webpack_public_path__ + "img/bridge_medium.ff84708f.png";